import { render, staticRenderFns } from "./openDistribution.vue?vue&type=template&id=9106c91c&scoped=true&"
import script from "./openDistribution.vue?vue&type=script&lang=js&"
export * from "./openDistribution.vue?vue&type=script&lang=js&"
import style0 from "./openDistribution.vue?vue&type=style&index=0&id=9106c91c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9106c91c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/jenkins/workspace/product_operation/package_operation-saasmobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9106c91c')) {
      api.createRecord('9106c91c', component.options)
    } else {
      api.reload('9106c91c', component.options)
    }
    module.hot.accept("./openDistribution.vue?vue&type=template&id=9106c91c&scoped=true&", function () {
      api.rerender('9106c91c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/openDistribution.vue"
export default component.exports